window.PlummeI18n.register('en', {
  "clo.cash.quickComments": "Quick comments",
  "clo.cash.quickCountLabel": "Counted by general manager",
  "clo.cash.quickCountText": "Cash on hand was physically counted at 31 December {{year}} by the general manager.",
  "clo.cash.quickSheetLabel": "Count sheet saved",
  "clo.cash.quickSheetText": "The signed count sheet was reviewed and saved with the accounting documentation.",
  "clo.cash.quickReportLabel": "Checked against cash report",
  "clo.cash.quickReportText": "The count was checked against the cash report at 31 December {{year}}.",
  "clo.cash.openPosting": "Create manual posting",
  "clo.cash.postingTitle": "Correct cash on hand",
  "clo.cash.postingDescription": "Correction after cash count {{year}}",
  "clo.cash.postingLoadError": "Could not load manual posting.",
  "clo.cash.postingSaved": "The posting was recorded. Review the difference again."
});
